import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import "./i18n";
// Non-negotiable 2: the Tamil font is BUNDLED, not system-provided. Imported
// here rather than linked from a CDN because the ticket has to render at a
// door with no signal -- a webfont fetched over the network is exactly the
// thing that fails at 6:55pm. Vite fingerprints the woff2 files into the
// build and the service worker precaches them.
import "@fontsource-variable/noto-serif-tamil/wght.css";
import "@fontsource-variable/noto-sans-tamil/wght.css";
import "./styles/tokens.css";
import "./styles/components.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
